import { AVATAR_COLORS } from "@clubap/shared";
import type { PlayerSelection } from "../game/RoomStage.js";
import { ClubBadges } from "./ClubBadges.js";
import { IconAmigos } from "./icons.js";

interface Props {
  players: PlayerSelection[];
  selfSessionId: string | null;
  onSelect: (player: PlayerSelection) => void;
  onClose: () => void;
}

function swatch(colorIndex: number): string {
  const color = AVATAR_COLORS[colorIndex] ?? AVATAR_COLORS[0];
  return `#${color.toString(16).padStart(6, "0")}`;
}

/**
 * La cartelera de la sala: quién está aquí. En un mundo social saber que hay
 * alguien más importa tanto como verlo, sobre todo cuando el otro está detrás de un
 * edificio.
 *
 * La cabecera va en dorado y no en azul como el cuerpo: es el mismo recurso que usa
 * el letrero de la sala para decir "esto es información del sitio, no tuya".
 */
export function PlayerList({ players, selfSessionId, onSelect, onClose }: Props) {
  const sorted = [...players].sort((a, b) => {
    if (a.sessionId === selfSessionId) return -1;
    if (b.sessionId === selfSessionId) return 1;
    return a.nickname.localeCompare(b.nickname);
  });

  return (
    <aside className="cartelera" aria-label="Quién está en la sala">
      <header className="cartelera__cabecera">
        <IconAmigos size={16} />
        <span className="cartelera__titulo">
          EN ESTA SALA · {String(players.length).padStart(2, "0")}
        </span>
        <button
          className="cartelera__cerrar"
          type="button"
          onClick={onClose}
          aria-label="Cerrar lista"
        >
          ×
        </button>
      </header>

      <ul className="cartelera__lista">
        {sorted.map((player) => (
          <li key={player.sessionId}>
            <button className="cartelera__fila" type="button" onClick={() => onSelect(player)}>
              <span className="cartelera__color" style={{ background: swatch(player.color) }} />
              <span className="cartelera__nombre">{player.nickname}</span>
              <ClubBadges clubs={player.clubs} />
              {player.sessionId === selfSessionId && <span className="cartelera__tag">TÚ</span>}
            </button>
          </li>
        ))}
      </ul>

      <p className="cartelera__nota">Clic en un jugador para ver su tarjeta.</p>
    </aside>
  );
}
